export const products = [
        {
            category: 'Produktna berza',
            text: 'Cene žitarica i đubriva na produktnoj berzi u Novom sadu',
            config: 'nsProducts',
            subcategories:[
            {
                name: 'Kukuruz',
                text: 'Cene kukuruza na produktnoj berzi u Novom sadu'
            },
            {
                name: 'Pšenica',
                text: 'Cene pšenice na produktnoj berzi u Novom sadu'
            },
            {
                name: 'Soja',
                text: 'Cene soje na produktnoj berzi u Novom sadu'
            },
            {
                name: 'Đubriva',
                text: 'Cene đubriva na produktnoj berzi u Novom sadu'
            },
            {
                name: 'Sačma',
                text: 'Cene sačme na produktnoj berzi u Novom sadu'
            },
            {
                name: 'Stočni ječam',
                text: 'Cene stocnog ječma na produktnoj berzi u Novom sadu'
            }
        ]
        }
    ]
